import dayjs from "dayjs";

const serviceProvider = [
    "迅捷管道工程",
    "绿净环境服务",
    "四季园林",
    "安泊智能",
    "园区万事达"
]

const fromList = [
    "公众上报",
    "人员巡检",
    "无人机巡检",
    "巡检车巡检"
]


const typeList = [
    "垃圾堆放",
    "道路损坏",
    "泊车问题",
    "井盖问题",
    "草坪维护"
]

const status = [
    "已解决",
    "解决中",
    "已打回",
    "待审核",
]

function getData() {
    let array = [];
    for (let i = 0; i < 256; i++) {
        let statusNo = getRandomInt(0, 3);
        array.push({
            no: i,
            type: typeList[getRandomInt(0, 4)],
            from: fromList[getRandomInt(0, 3)],
            serviceProvider: serviceProvider[getRandomInt(0, 4)],
            status: status[statusNo],
            location: "121.3213,30.2222",
            create_at: getTime(Date.now()),
            end_at: statusNo === 1 ? "" : getTime(Date.now() + getRandomInt(100000, 300000)),
        })
    }
    return array;
}

function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getTime(timestamp) {
    return dayjs(timestamp).format("YYYY-MM-DD HH:mm:ss")
}

export default {
    data:getData(),
    serviceProvider,
    fromList,
    typeList,
    status
};